import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MultiSelectFieldSettings, CrawfordSnackbarService } from 'crawford-shell';
import { SearchFilterService } from '../services/search-filter.service';
import { AccordionService } from '../services/accordion.service';

@Component({
  selector: 'app-claim-handler-search',
  templateUrl: './claim-handler-search.component.html',
  styleUrls: ['./claim-handler-search.component.scss']
})
export class ClaimHandlerSearchComponent
  implements OnInit {

  @Input() public group: FormGroup;
  @Input() public accordionGroupName: string; // = 'handler';

  public leadAdjusterFilters;
  public leadTechnicianFilters;
  public assistingAdjusterFilters;
  public readonly apiFieldSettings: MultiSelectFieldSettings = { value: 'code', text: 'displayText' };


  constructor(private searchFilterService: SearchFilterService,
    private snackbarService: CrawfordSnackbarService,
    private accordionService: AccordionService) {
  }

  ngOnInit() {
    ['leadAdjuster', 'leadTechnician', 'assistingAdjuster']
    .forEach((name) => this.accordionService.addFormControl(this.accordionGroupName, this.group, name));

    const claimSource: string = this.group.value['claimSource'];
    this.loadFilterValues(claimSource);
  }

  public loadFilterValues(claimSource: string): void {
    const handlers = this.searchFilterService.getSearchFilterHandlers(claimSource);

    this.leadAdjusterFilters = handlers;
    this.leadTechnicianFilters = handlers;
    this.assistingAdjusterFilters = handlers;
  }

  queryFailed($event): void {
    this.snackbarService.displayErrorMessage('There was an error obtaining handlers');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-handler-search/claim-handler-search.component.ts